import { type AdminOrderInquiryDetail, ORDER_INQUIRY_RESOLUTION_LABELS } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { formatDateTime } from '@/shared/lib';

interface OrderInquiryAnswerViewProps {
  readonly inquiry: AdminOrderInquiryDetail;
}

/** 답변 완료 문의의 처리 결과·답변·답변 일시·처리자. */
export const OrderInquiryAnswerView = ({ inquiry }: OrderInquiryAnswerViewProps): ReactElement => (
  <section
    aria-label="답변"
    className="rounded-2xl border border-foreground/[0.06] bg-card px-5 py-4"
  >
    <h2 className="font-medium">답변</h2>
    <p className="mt-3 whitespace-pre-wrap text-sm">{inquiry.answer}</p>
    <dl className="mt-4 grid grid-cols-[6rem_1fr] gap-y-2 text-sm">
      <dt className="text-muted-foreground">처리 결과</dt>
      <dd>{inquiry.resolution ? ORDER_INQUIRY_RESOLUTION_LABELS[inquiry.resolution] : '—'}</dd>
      <dt className="text-muted-foreground">답변 일시</dt>
      <dd>{inquiry.answeredAt ? formatDateTime(inquiry.answeredAt) : '—'}</dd>
      <dt className="text-muted-foreground">처리자</dt>
      <dd>{inquiry.answeredByName ?? '—'}</dd>
    </dl>
  </section>
);
